export default (function dropdownInit() {
    const dropdown = {
        switchValue() {
            $(document).on('click', '.js--dropdown__switch_text', function () {
                const currentValue = $(this).text();
                const $dropdown = $(this).closest('.dropdown');
                const $dropdownItem = $(this).closest('.dropdown__menu_item');
                const $dropdownText = $dropdown.find('.js--dropdown__text');
                const $dropdownLink = $dropdown.find('.js--dropdown__link');
                const input = $dropdown.find('.js--dropdown-selected');
                const dataValue = $(this).data('value');
                $dropdownText.html(currentValue);
                $dropdownLink.attr('href', `tel:${currentValue}`);
                $('.dropdown__menu_item').removeClass('dropdown__menu_item--active');
                $dropdownItem.addClass('dropdown__menu_item--active');
                if (input.length > 0) {
                    input.val(dataValue || currentValue.trim());
                    input.closest('.form-group').removeClass('form-group--error');
                }
            });
        },
        controlHandler() {
            $(document).on('click', '.js--close_attribute', function () {
                $('.dropdown__menu').removeClass('show');
            });
        },
    };
    $(document).ready(() => {
        dropdown.switchValue();
        dropdown.controlHandler();
    });
}());
